import React, { Component } from 'react';

import { SimpleForm } from 'components/form';
import { TextInput, LongTextInput } from 'components/input';
import { change as changeAction } from 'redux-form';
import { connect } from 'react-redux';

import { InputOptions } from 'util/constants';

import * as urls from './urls'
import * as utils from './utils'
import { getActiveLanguage } from 'util/constants';

import { Edit } from "components/detail";
import DisabledInput from "components/input/DisabledInput";

import { crudGetList as crudGetListAction } from 'actions/dataActions';


const active_lang = getActiveLanguage();

class ReminderConfigUpdateEditBase extends Component {
  handleSubmit = (props, basePath) => () => {
    const { formValues } = this.props;

    const dummy_changelogs = {
      changelog_en: '',
      changelog_th: '',
      changelog_vi: '',
    };

    const client_release_info = {
      app_type: formValues.app_type,
      client_type: formValues.client_type,
      version_number: utils.generateVersionNumber(formValues.latest_version_info.version_number),
      support_status: utils.CLIENT_SUPPORTED,

      ...dummy_changelogs,
      changelog_en: formValues.latest_version_info.changelog_en.replace(/(\r\n|\n|\r)/gm, '\n'),
      [`changelog_${active_lang}`]: formValues.latest_version_info[`changelog_${active_lang}`].replace(/(\r\n|\n|\r)/gm, '\n'),
    };
    const submitData = {
      client_release_infos: [
        client_release_info,
        {
          ...client_release_info,
          client_type: formValues.internal_client_type,
        }
      ],
    };

    props.crudUpdate(
      props.resource, 
      '', 
      submitData,
      {},
      props.editBackendPath,
      basePath
    );
  };

  render() {
    return (
      <Edit 
        {...this.props}
        title="Edit New Update Reminder"
        editBackendPath={urls.reminderConfigEditBackendPath}
        basePath={urls.reminderConfigFrontendPath}
        showPath={`update/`}
        hasShow={true}
        handleSubmit={this.handleSubmit}
      >
        <SimpleForm>
          <DisabledInput
            source='app_type'
            label='App type'
            choices={utils.APP_TYPE_LIST}
          />
          <DisabledInput
            source='client_type'
            label='Platform'
            choices={utils.CLIENT_TYPE_LIST}
          />
          <TextInput
            source='latest_version_info.version_number'
            label='Version'
            isRequired={true}
            options={InputOptions}
          />
          <LongTextInput
            source='latest_version_info.changelog_en'
            label="What's New (EN)"
            options={InputOptions}
          />
          <LongTextInput
            source={`latest_version_info.changelog_${active_lang}`}
            label={`What's New (${active_lang.toUpperCase()})`}
            options={InputOptions}
          />
        </SimpleForm>
      </Edit>
    )
  }
}

export const ReminderConfigUpdateEdit = connect(
  (state) => {
    return {
      submitFailed: (state.form['record-form'] || {}).submitFailed,
      syncErrors: ((state.form['record-form'] || {}).syncErrors || {}),
      formValues: ((state.form['record-form'] || {}).values || {}),
      formInitial: ((state.form['record-form'] || {}).initial || {}),
    }
  },
  {
    change: changeAction,
    customFetch: () => (
      crudGetListAction(
        utils.ReminderConfigResourceName, 
        urls.reminderConfigBackendPath,
        {}
      )
    ),
  }
)(ReminderConfigUpdateEditBase);



// WEBPACK FOOTER //
// ./src/routes/advancedFunction/ReminderConfigUpdateEdit.js